import React from 'react';
import { ArrowRight, Clock, AlertTriangle, CheckCircle, XCircle, Phone, Mail } from 'lucide-react';
const RefundPolicy = () => {
  return <div className="w-full" data-id="element-652">
      {/* Hero Section */}
      <section className="bg-[#0a2e4a] text-white py-16" data-id="element-653">
        <div className="container mx-auto px-4" data-id="element-654">
          <div className="max-w-3xl mx-auto text-center" data-id="element-655">
            <h1 className="text-4xl font-bold mb-6" data-id="element-656">Refund Policy</h1>
            <p className="text-xl" data-id="element-657">
              Information about our refund terms and procedures
            </p>
          </div>
        </div>
      </section>
      {/* Main Content */}
      <section className="py-16" data-id="element-658">
        <div className="container mx-auto px-4" data-id="element-659">
          <div className="max-w-3xl mx-auto" data-id="element-660">
            <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-661">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-662">
                Refund Policy – Peakwave
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-663">
                Thank you for choosing Peakwave. We value your trust and are
                committed to ensuring your complete satisfaction with our
                services. If you have any concerns about your service plan or
                purchase, we'll work quickly and fairly to resolve them.
              </p>
              <div className="border-l-4 border-[#0a2e4a] pl-4 mb-8" data-id="element-664">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-3" data-id="element-665">
                  Cancellation & Refund Rights
                </h3>
                <p className="text-gray-600 mb-3" data-id="element-666">
                  You have the right to cancel your service plan within 14 days
                  of purchase and receive a full refund. To do this, please
                  contact us within the 14-day period, and we'll process your
                  refund promptly.
                </p>
                <p className="text-gray-600 mb-3" data-id="element-667">
                  If you cancel after 14 days but within 28 days of purchase,
                  you may be eligible for a partial refund at our discretion,
                  depending on any services already provided under your plan.
                </p>
                <p className="text-gray-600" data-id="element-668">
                  Please note that refunds or cancellations are not available
                  after 28 days from the purchase date. We recommend reviewing
                  your service plan carefully and contacting us as soon as
                  possible if you wish to cancel.
                </p>
              </div>
              <div className="mb-8" data-id="element-669">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-670">
                  How to Request a Refund
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-671">
                  To request a refund, please get in touch with our team using
                  the contact details below:
                </p>
                <div className="space-y-4 mb-6 bg-gray-50 p-4 rounded-md" data-id="element-672">
                  <div className="flex items-center" data-id="element-673">
                    <Phone className="text-[#f05a28] mr-3 flex-shrink-0" size={20} data-id="element-674" />
                    <span className="text-gray-600" data-id="element-675">
                      Phone:{' '}
                      <a href="tel:08000554969" className="text-[#0a2e4a] font-semibold hover:underline" data-id="element-676">
                        0800 055 4969
                      </a>
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-677">
                    <Mail className="text-[#f05a28] mr-3 flex-shrink-0" size={20} data-id="element-678" />
                    <span className="text-gray-600" data-id="element-679">
                      Email:{' '}
                      <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#0a2e4a] font-semibold hover:underline" data-id="element-680">
                        sunitalimbu9596@gmail.com
                      </a>
                    </span>
                  </div>
                </div>
                <p className="text-gray-600" data-id="element-681">
                  We'll assess your request promptly and process any approved
                  refunds. You'll receive confirmation once your refund has been
                  completed.
                </p>
              </div>
              <div className="mb-8" data-id="element-682">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-683">
                  Payment Methods
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-684">
                  Peakwave accepts payments via:
                </p>
                <ul className="list-disc list-inside text-gray-600 mb-4" data-id="element-685">
                  <li data-id="element-686">Phone card payments</li>
                  <li data-id="element-687">Online payments through our website</li>
                  <li data-id="element-688">Cheques by post (please contact us for details)</li>
                  <li data-id="element-689">BACS or Direct Debit</li>
                </ul>
                <p className="text-gray-600" data-id="element-690">
                  Your 14-day cancellation right applies regardless of payment
                  method.
                </p>
              </div>
              <div className="mb-8" data-id="element-691">
                <h3 className="text-xl font-semibold text-[#0a2e4a] mb-4" data-id="element-692">
                  Refund Processing
                </h3>
                <p className="text-gray-600" data-id="element-693">
                  All refunds will be issued to the original payment method used
                  at purchase. For security reasons, refunds cannot be made to
                  alternative accounts or cards.
                </p>
              </div>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-694">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-695">
                Payment Follow-Up
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-696">
                After purchasing a plan, Peakwave will contact you to confirm
                activation and inform you when payment will be processed. Please
                ensure sufficient funds are available. If payment fails, we'll
                contact you to confirm whether you wish to proceed. Without a
                timely response, your plan will be cancelled.
              </p>
              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6" data-id="element-697">
                <div className="flex items-start" data-id="element-698">
                  <AlertTriangle className="text-yellow-500 mr-3 flex-shrink-0" size={20} data-id="element-699" />
                  <p className="text-sm text-gray-600" data-id="element-700">
                    Payments must be made by the plan holder or an authorised
                    individual. We don't accept payments made under power of
                    attorney or other third-party authorisations.
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md mb-8" data-id="element-701">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-702">
                Claims & Support
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-703">
                To book a repair or submit a claim, please contact us
                immediately:
              </p>
              <div className="space-y-4 mb-6 bg-gray-50 p-4 rounded-md" data-id="element-704">
                <div className="flex items-center" data-id="element-705">
                  <Mail className="text-[#f05a28] mr-3 flex-shrink-0" size={20} data-id="element-706" />
                  <span className="text-gray-600" data-id="element-707">
                    Email:{' '}
                    <a href="mailto:sunitalimbu9596@gmail.com" className="text-[#0a2e4a] font-semibold hover:underline" data-id="element-708">
                      sunitalimbu9596@gmail.com
                    </a>
                  </span>
                </div>
                <div className="flex items-center" data-id="element-709">
                  <Phone className="text-[#f05a28] mr-3 flex-shrink-0" size={20} data-id="element-710" />
                  <span className="text-gray-600" data-id="element-711">
                    Phone:{' '}
                    <a href="tel:08000554969" className="text-[#0a2e4a] font-semibold hover:underline" data-id="element-712">
                      0800 055 4969
                    </a>
                  </span>
                </div>
              </div>
              <p className="text-gray-600" data-id="element-713">
                Our team will assist you and begin the repair process promptly.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-md" data-id="element-714">
              <h2 className="text-2xl font-bold text-[#0a2e4a] mb-6" data-id="element-715">
                Dispute Resolution
              </h2>
              <p className="text-gray-600 mb-6" data-id="element-716">
                If you have any issues related to payment or service, please
                contact Peakwave first before raising a chargeback with your
                bank. We aim to resolve all concerns fairly and promptly.
                Initiating a chargeback without prior contact may delay your
                refund.
              </p>
              <div className="flex items-center justify-center mt-8" data-id="element-717">
                <a href="/contact" className="bg-[#0a2e4a] text-white px-8 py-3 rounded-md font-semibold text-center hover:bg-[#164875] transition flex items-center" data-id="element-718">
                  Contact Our Support Team{' '}
                  <ArrowRight size={18} className="ml-2" data-id="element-719" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default RefundPolicy;